// src/components/BetaStats/BetaMap.jsx
// A small East Coast map with a pin for each beta site. Inline SVG, no map library and no outside
// requests. Sites arrive already rounded to city level by the API, so a pin never marks a building.
import React from 'react';
import { PROJECTION, STATE_PATHS } from './eastCoastMapData';

// The part of the generated map that is shown (x, y, width, height in map units).
const VIEW = { x: 40, y: 135, w: 460, h: 330 };

const project = (lat, lng) => ({
  x: PROJECTION.tx + PROJECTION.k * ((lng * Math.PI) / 180),
  y: PROJECTION.ty - PROJECTION.k * Math.log(Math.tan(Math.PI / 4 + (lat * Math.PI) / 360)),
});

const placeName = (p) => (p.region ? `${p.city}, ${p.region}` : p.city);

const BetaMap = ({ locations }) => {
  const pins = locations
    .filter((p) => Number.isFinite(p.lat) && Number.isFinite(p.lng))
    .map((p) => ({ ...p, ...project(p.lat, p.lng) }))
    .filter((p) => p.x >= VIEW.x && p.x <= VIEW.x + VIEW.w && p.y >= VIEW.y && p.y <= VIEW.y + VIEW.h);

  if (pins.length === 0) return null;

  return (
    <svg
      className="beta-map"
      viewBox={`${VIEW.x} ${VIEW.y} ${VIEW.w} ${VIEW.h}`}
      role="img"
      aria-label={`Map of active beta testing sites: ${pins.map(placeName).join(', ')}`}
    >
      <g className="beta-map-states">
        {STATE_PATHS.map((s) => (
          <path key={s.id} d={s.d} />
        ))}
      </g>
      {pins.map((p) => (
        <g className="beta-map-pin" key={`${p.city}|${p.region}`} transform={`translate(${p.x} ${p.y})`}>
          <title>{p.home ? `${placeName(p)} (home base)` : placeName(p)}</title>
          <circle className="beta-map-pulse" r="6" />
          {p.home ? (
            <path className="beta-map-home" d="M0 -10 L-9 -2 H-6 V7 H-2 V2 H2 V7 H6 V-2 H9 Z" />
          ) : (
            <circle className="beta-map-dot" r="5" />
          )}
          <text className="beta-map-label" x={p.home ? 13 : 11} y="5">
            {p.city}
          </text>
        </g>
      ))}
    </svg>
  );
};

export default BetaMap;
